import { keyBy } from 'lodash'
import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import {
  getMenusForRevenueCenter,
  getMenusStatus,
} from 'store/RevenueCenters/selector'

const RevenueCenterItem = ({ name, id, uuid }) => {
  const history = useHistory()

  const menus = useSelector((state) =>
    getMenusForRevenueCenter(state, id)
  )
  const status = useSelector((state) => getMenusStatus(state, uuid))

  const statusByType = keyBy(status, 'type')

  const onClickItem = () => {
    history.push(`/revenue-centers/${uuid}`)
  }

  return (
    <div className="item">
      <div className="row" onClick={onClickItem} role="button">
        <div className="item-info-wrapper -shorter-aligment -bold">
          {name}
        </div>
        <div className="item-info-wrapper -fit-content">
          {menus.map(({ uuid, serviceType, displayName }) => (
            <div className="item-type" key={uuid}>
              <span
                className={`item-type__dot  -${
                  statusByType[
                    serviceType === 'Concessions'
                      ? 'PICKUP'
                      : serviceType.toUpperCase()
                  ]?.availability ?? 'on'
                }`}
              ></span>
              <p>
                <span className="item-type--bold">
                  {serviceType === 'Concessions'
                    ? 'Pickup'
                    : serviceType}
                </span>
                : {displayName}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default RevenueCenterItem
